import { render } from "./IconGlobe.vue?vue&type=template&id=231b39f4"
const script = {}

import exportComponent from "/home/balluff-sales-app-stagelinksderi/sales-app.stage.balluff.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__